import React from 'react';
import classNames from 'classnames/bind';
import styles from './Scholar.scss';

const cx = classNames.bind(styles);
function Scholar({ initModal }) {
  return (
    <div className={cx('Scholar')}>
      <h5 className="title">끝내주는 장학금 안내</h5>
      <span className="close" onClick={initModal} />
      <div>
        <h5 className="subTitle">이용안내</h5>
        <ul className="list">
          <li>
            &middot; 챌린지 미션에 통과하면 누구나 끝내주는 장학금의 주인공이 될
            수 있습니다.{' '}
          </li>
          <li>
            &middot; 1년 동안 모든 미션에 성공하면, 총 100만원의 장학금을
            지급합니다.
          </li>
        </ul>
        <h5 className="subTitle">* 아래 유의사항을 꼭 확인해주세요!</h5>
        <ul className="list">
          <li>
            &middot; 장학금 신청은 패키지 상품을 구매하신 고객에 한해 아이디당
            1번만 가능합니다.
          </li>
          <li>
            &middot; 서비스에 로그인 후 내 학습 > 페이백 챌린지에서 '도전하기'
            버튼을 눌러주세요. 도전하기 버튼을 누르시면 익월 1일부터 챌린지
            프로그램이 시작됩니다.
          </li>
          <li>
            &middot; 총 12회로 구성된 챌린지는 매 회차당 1일부터 24일까지 매일
            학습 미션을 완료하고, 25일부터 말일까지 최종 리뷰 1회만 작성하면
            성공으로 인정됩니다(월 단위). 이러한 매월 학습 프로그램을 총 12회
            성공하면, 끝내주는 장학금 100만원을 받으실 수 있습니다.
          </li>
          <li>
            &middot; 챌린지를 시작한 후 중도에 멈출 수 없으며, 미션 실패 시
            장학금 도전은 종료됩니다.
          </li>
          <li>&middot; 제세공과금 본인 부담</li>
        </ul>
      </div>
    </div>
  );
}

export default Scholar;
